import React, { ReactNode } from 'react'

import classNames from 'classnames'

import styles from './style.module.scss'

interface ObserverObj {
  element?: HTMLDivElement
  ref?: HTMLDivElement
  observer?: ResizeObserver
  resizeTimer?: number
  prevWidth?: number
  calcHeight: () => void
  clear: () => void
}

interface ItemsInfo {
  widthList: number[]
  containerW?: number
  prefixW?: number
  postfixW?: number
}

interface BreakInfo {
  front?: boolean
  end?: boolean
}

interface FoldableFlowProps<T = any> {
  items: T[]
  className?: string
  renderItem: (item: T, idx: number, array: T[]) => ReactNode
  renderPrefix?: (
    isFold: boolean,
    viewCnt: number,
    itemList: T[],
    toggle: (fold?: boolean) => void,
  ) => ReactNode
  renderPostfix?: (
    isFold: boolean,
    viewCnt: number,
    itemList: T[],
    toggle: (fold?: boolean) => void,
  ) => ReactNode
  emptyWidth?: number
  emptyLines?: number[]
  defaultFold?: boolean
}

interface FoldableFlowState<T = any> {
  itemList: T[]
  viewCnt: number
  subIdx: number
  isFold: boolean
}

class FoldableFlow<T = any> extends React.Component<FoldableFlowProps<T>, FoldableFlowState<T>> {
  state: FoldableFlowState<T> = {
    itemList: [],
    viewCnt: 0,
    subIdx: 0,
    isFold: true,
  }

  childInfo: any = null
  observerObj!: ObserverObj
  itemsInfo?: ItemsInfo

  componentDidMount() {
    this.createObserver()
    this.applyList()

    const { defaultFold } = this.props

    if (defaultFold != null) {
      this.setState({
        isFold: defaultFold,
      })
    }
  }

  componentDidUpdate(prevProps: FoldableFlowProps<T>) {
    const { items, className, renderPrefix, renderPostfix, emptyWidth } = this.props

    if (prevProps.items !== items) {
      this.applyList()
    } else if (
      prevProps.className !== className ||
      prevProps.renderPrefix !== renderPrefix ||
      prevProps.renderPostfix !== renderPostfix ||
      prevProps.emptyWidth !== emptyWidth
    ) {
      this.forceUpdate()
    }
  }

  componentWillUnmount() {
    this.observerObj.clear()
  }

  applyList = () => {
    const { items } = this.props

    this.setState({
      itemList: items,
    })
  }

  toggle = (fold?: boolean) => {
    const { isFold } = this.state

    const value = fold != null ? fold : !isFold

    console.log(' --- toggle : ', value)

    this.setState({
      isFold: value,
    })
  }

  createObserver = () => {
    // const { itemSelector, childSelector } = this.props

    if (this.observerObj == null) {
      this.observerObj = {} as ObserverObj

      this.observerObj.calcHeight = () => {
        if (this.observerObj.resizeTimer != null) {
          cancelAnimationFrame(this.observerObj.resizeTimer)
        }
        this.observerObj.resizeTimer = requestAnimationFrame(() => {
          const { emptyWidth } = this.props
          const emptyW = emptyWidth != null ? emptyWidth : 0

          const { element } = this.observerObj

          if (element != null && element.offsetWidth > 0 && element.offsetHeight > 0) {
            if (this.observerObj.prevWidth !== element.offsetWidth) {
              this.observerObj.prevWidth = element.offsetWidth

              const obsElem = element
              const itemsElem = obsElem.querySelector('.flowItems') as HTMLElement | null
              const prefixElem = obsElem.querySelector('.prefix') as HTMLElement | null
              const postfixElem = obsElem.querySelector('.postfix') as HTMLElement | null

              const prefixW = prefixElem != null ? prefixElem.offsetWidth : 0
              const postfixW = postfixElem != null ? postfixElem.offsetWidth : 0

              if (itemsElem != null && itemsElem.children.length > 0) {
                const allWidth = obsElem.offsetWidth

                if (this.itemsInfo == null) {
                  const widthList = Array.from(itemsElem.children).map((child) => {
                    let w = 0
                    Array.from(child.children).forEach((realItem: Element) => {
                      w += (realItem as HTMLElement).offsetWidth
                    })
                    return w
                  })

                  this.itemsInfo = {
                    widthList,
                  }
                }
                this.itemsInfo.containerW = obsElem.offsetWidth
                this.itemsInfo.prefixW = prefixW
                this.itemsInfo.postfixW = postfixW

                let idx = 0
                // let item = itemsElem.children[idx]
                // if (childSelector != null && idx === 0) {
                //   const realItem = itemSelector != null ? item.querySelector(itemSelector) : item
                //   if (this.childInfo == null) {
                //     const childItems = realItem.querySelectorAll(childSelector)
                //     const total = realItem.offsetWidth
                //     let margin = total
                //     const itemWidthList = Array.from(childItems).map((childItem) => {
                //       const w = childItem.offsetWidth
                //       margin = margin - w
                //       return w
                //     })
                //     this.childInfo = {
                //       total,
                //       margin,
                //       wList: itemWidthList,
                //     }
                //   }

                //   const maxW = allWidth - prefixW - postfixW

                //   console.log(
                //     ' --- calc child width : ',
                //     maxW,
                //     realItem.offsetWidth,
                //     this.childInfo,
                //   )
                //   console.log(' --- calc ext : ', prefixW, postfixW)

                //   const { total, margin, wList } = this.childInfo
                //   if (maxW < total && wList.length > 1) {
                //     let mIdx = -1
                //     let mWidth = margin
                //     while (mWidth + wList[mIdx + 1] < maxW) {
                //       mIdx += 1
                //       mWidth += wList[mIdx]
                //     }
                //     if (mIdx >= 0 && mIdx < wList.length) {
                //       item.setAttribute('viewIdx', mIdx)
                //       console.log(' --- view count : 1, childIdx : ', mIdx)

                //       this.setState({
                //         viewCnt: 1,
                //         subIdx: mIdx,
                //       })
                //     } else {
                //       item.removeAttribute('viewIdx')
                //       this.setState({
                //         viewCnt: 0,
                //         subIdx: 0,
                //       })
                //     }
                //     return
                //   }

                //   item.removeAttribute('viewIdx')
                // }

                const { widthList } = this.itemsInfo

                let calWidth = prefixW
                while (
                  idx < itemsElem.children.length &&
                  allWidth - emptyW > calWidth + widthList[idx]
                ) {
                  calWidth += widthList[idx]
                  idx += 1
                }

                if (postfixW > 0 && idx > 0) {
                  if (calWidth + postfixW + 5 > allWidth - emptyW) {
                    idx -= 1
                  }
                }

                const count = Math.max(idx, 0)

                console.log(' --- view count : ', count)

                this.setState({
                  viewCnt: count,
                  subIdx: 0,
                })
              }
              this.observerObj.resizeTimer = undefined
            }
          }
        })
      }

      this.observerObj.observer = new ResizeObserver(() => {
        this.observerObj.calcHeight()
      })

      this.observerObj.clear = () => {
        const { observer, element, resizeTimer } = this.observerObj
        if (observer != null && element != null) {
          observer.disconnect()
          if (resizeTimer != null) {
            cancelAnimationFrame(resizeTimer)
          }
        }
      }
    }
  }

  setRef = (ref: HTMLDivElement | null) => {
    if (ref != null) {
      this.createObserver()

      if (this.observerObj.ref !== ref || this.observerObj.element !== ref) {
        this.observerObj.clear()

        this.observerObj.element = ref
        this.observerObj.ref = ref

        if (this.observerObj.element != null) {
          this.observerObj.calcHeight()
          this.observerObj.observer!.observe(this.observerObj.element, { box: 'border-box' })
        }
      }
    }
  }

  getBreakInfo = (isFold: boolean, emptyW: number, _viewCnt: number): BreakInfo[] => {
    if (this.itemsInfo == null) {
      return []
    }

    const { emptyLines } = this.props
    const { containerW, prefixW, postfixW, widthList } = this.itemsInfo

    const ret: BreakInfo[] = []

    if (isFold === true && widthList.length > 1) {
      return ret
    }

    let idx = 0
    let line = 0
    let emptyW0 = emptyLines == null || emptyLines.indexOf(line) > -1 ? emptyW : 0
    let curWidth = emptyW0 + widthList[idx]
    let breakInfo: BreakInfo = {}
    if (prefixW && prefixW > 0) {
      // idx === 0일 때만 해당.
      curWidth += prefixW
      if (curWidth > (containerW || 0)) {
        breakInfo.front = true
        line += 1
        emptyW0 = emptyLines == null || emptyLines.indexOf(line) > -1 ? emptyW : 0
        curWidth = emptyW0 + widthList[idx]
      }
    }
    ret.push(breakInfo)

    while (idx < widthList.length - 1) {
      idx += 1
      breakInfo = {}
      curWidth += widthList[idx]
      if (curWidth > (containerW || 0)) {
        breakInfo.front = true
        line += 1
        emptyW0 = emptyLines == null || emptyLines.indexOf(line) > -1 ? emptyW : 0
        curWidth = emptyW0 + widthList[idx]
      }
      ret.push(breakInfo)
    }

    if (postfixW && postfixW > 0) {
      if (curWidth + postfixW > (containerW || 0)) {
        ret[ret.length - 1].end = true
      }
    }

    return ret
  }

  render() {
    const { itemList, viewCnt, isFold } = this.state
    const { className, renderItem, renderPrefix, renderPostfix, emptyWidth } = this.props

    const emptyW = emptyWidth != null ? emptyWidth : 0

    const breakInfo = this.getBreakInfo(isFold, emptyW, viewCnt)

    const itemElems = itemList.map((item, idx, array) => {
      const elem = renderItem(item, idx, array)
      const key = `item_${idx}`
      const breakProp = breakInfo.length > idx ? breakInfo[idx] : {}
      const itemCls = classNames('ffItem', {
        // 측정 전(itemsInfo == null)에는 숨기지 않고 일단 표시한다 — fold CSS(nowrap +
        // overflow hidden)가 한 줄로 클립하므로 깨지지 않고, 측정 완료 후 viewCnt로 보정된다.
        // (측정 전 visibility:hidden으로 비워두면 Firefox에서 강제 reflow가 끝날 때까지
        // preview ↔ 수신자 전환 구간이 빈 화면으로 보이는 지연이 발생.)
        hidden:
          this.itemsInfo != null &&
          isFold === true &&
          viewCnt >= 0 &&
          idx >= viewCnt &&
          itemList.length > 1,
        only: itemList.length === 1,
        breakFront: breakProp.front === true,
        breakEnd: breakProp.end === true,
      })
      const itemAttrs: React.HTMLAttributes<HTMLSpanElement> = {
        className: itemCls,
      }
      // if (itemList.length === 1 && this.itemsInfo != null) {
      //   const { containerW, prefixW } = this.itemsInfo;
      //   const maxWidth = containerW - prefixW - emptyW;
      //   itemAttrs.style = { maxWidth: `${maxWidth - 5}px` }
      // }
      return (
        <span key={key} {...itemAttrs}>
          {elem}
          <span className={classNames('ffSpace')}>&nbsp; </span>
        </span>
      )
    })

    let prefix: ReactNode = ''
    if (renderPrefix != null) {
      const elem = renderPrefix(isFold, viewCnt, itemList, this.toggle)
      prefix = <span className={classNames('prefix')}>{elem}</span>
    }

    let postfix: ReactNode = ''
    if (renderPostfix != null) {
      // console.log(' --- renderPostfix : ', isFold, viewCnt, subIdx)
      const elem = renderPostfix(isFold, viewCnt, itemList, this.toggle)
      postfix = <span className={classNames('postfix')}>{elem}</span>
    }

    const clsProps: Record<string, boolean> = {
      fold: isFold && itemList.length > 1,
      // 측정 전에는 viewCnt 기반인 postfix('외 N명')만 숨긴다 (값이 틀리므로).
      measuring: this.itemsInfo == null,
    }

    return (
      <div
        ref={(ref) => {
          this.setRef(ref)
        }}
        className={classNames(styles.foldableFlow, 'foldableFlow', className, clsProps)}
      >
        {prefix}
        <span className={classNames('flowItems')}>{itemElems}</span>
        {postfix}
      </div>
    )
  }
}

export default FoldableFlow
